import moment from 'moment';

export const COLORS = ['#0acf97', '#727cf5', '#6c757d', '#fa5c7c', '#ffbc00', '#39afd1', '#e3eaef'];

export const RED_COLORS = ['#FF0000', '#CC0000', '#FF3333', '#990000', '#FF6666', '#FFCCCC', '#FF9999'];

export const BLUE_COLORS = [ '#0000FF', '#00FFFF', '#0000CC', '#000099','#6666FF', '#66B2FF', '#CCE5FF'];

const convertToUnixTime = timestamp => moment(timestamp).format('x');

const formatUnixTime = (unixTime, format) => {
	const currentOffset = moment().utcOffset();
	// Guard the format argument: this is passed directly as a recharts `tickFormatter`,
	// and recharts 2 calls that as (value, index) where v1 called it as (value). Without
	// the type check the tick index arrives here as `format` and moment throws
	// "format.match is not a function" for every tick after the first (index 0 is falsy,
	// so it used to fall through to the default and only later ticks blew up).
	const pattern = typeof format === 'string' ? format : 'MMM D';
	return moment(Number(unixTime)).utcOffset(currentOffset).format(pattern);
};

const prepareTimeSeriesData = (data) => {
	return data && data.map(item => {
		const { timestamp, ...rest } = item;
		return {
			timestamp: convertToUnixTime(timestamp),	// convert dates to Unix Timestamp to use with scale='time' type='number'
			...rest
		};
	});
};

const formatPieLegendItem = (value, entry) => `${(entry.payload.percent * 100).toFixed(0)}% ${value}`;

const formatPercentage = value => `${value}%`;

export default {
	convertToUnixTime,
	formatUnixTime,
	prepareTimeSeriesData,
	formatPieLegendItem,
	formatPercentage
};